import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '@environment';
import { Alarm } from '@model';
import { MeteringType } from '@enums';
import { SxErrorService } from 'app/services/sx-error.service';

@Injectable()
export class AlarmsService {

  constructor(private http: HttpClient, private sxErrorService: SxErrorService) {}

  getAlarms(): Observable<Alarm[]> {
    return this.http
      .get<Alarm[]>(`${environment.apiEndpoint}/alarms`)
      .pipe(catchError((error: any) => throwError(() => new Error(error.json()))));
  }

  createAlarm(alarm: Alarm): Observable<Alarm> {
    return this.http
      .post<Alarm>(`${environment.apiEndpoint}/alarms`, alarm)
      .pipe(catchError((error: any) => throwError(() => new Error(error.json()))));
  }

  updateAlarm(alarm: Alarm): Observable<Alarm> {
    return this.http
      .post<Alarm>(`${environment.apiEndpoint}/alarms/${alarm.id}`, alarm)
      .pipe(catchError((error: any) => throwError(() => new Error(error.json()))));
  }

  removeAlarm(alarm: Alarm): Observable<Alarm> {
    return this.http
      .delete<any>(`${environment.apiEndpoint}/alarms/${alarm.id}`)
      .pipe(catchError((error: any) => throwError(() => new Error(error.json()))));
  }

  bulkCreateAlarms(alarms: Alarm[]): Observable<Alarm[]> {
    return this.http
      .post<Alarm[]>(`${environment.apiEndpoint}/alarms/bulkadd`, alarms)
      .pipe(catchError((error: any) => throwError(() => new Error(error.json()))));
  }

  bulkRemoveAlarms(ids: number[]): Observable<boolean> {
    return this.http
    .post<boolean>(`${environment.apiEndpoint}/alarms/bulkdelete`, ids)
    .pipe(catchError((error: any) => throwError(() => new Error(error.json()))));
  }

  bulkInactivateAlarms(alarms: Alarm[]): Observable<Alarm[]> {
    return this.http
    .post<Alarm[]>(`${environment.apiEndpoint}/alarms/bulkinactivate`, alarms)
    .pipe(catchError((error: any) => throwError(() => new Error(error.json()))));
  }

  bulkActivateAlarms(alarms: Alarm[]): Observable<Alarm[]> {
    return this.http
    .post<Alarm[]>(`${environment.apiEndpoint}/alarms/bulkactivate`, alarms)
    .pipe(catchError((error: any) => throwError(() => new Error(error.json()))));
  }

  createReportKey(): Observable<string> {
    return this.http
      .get<string>(`${environment.apiEndpoint}/alarms/key`)
      .pipe(catchError((error: any) => throwError(() => new Error(error.json()))));
  }

  exportAlarmsToExcel(key: string, paneType: MeteringType, ids: number[]): Observable<any> {
    return this.http
      .post<any>(`${environment.apiEndpoint}/reports/${key}/alarms/export/${paneType}`, ids, {
        responseType: 'blob' as 'json'
      })
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }
}
